var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25.45 25.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.45,12.725A12.725,12.725,0,1,0,12.725,25.45H25.45V23.329h-5.7A12.723,12.723,0,0,0,25.45,12.725ZM18.958,21.3a3.181,3.181,0,1,1,.7-4.444A3.181,3.181,0,0,1,18.958,21.3ZM18.8,7.406a3.181,3.181,0,1,1-2.043,4.009A3.181,3.181,0,0,1,18.8,7.406ZM12.725,2.121A3.181,3.181,0,1,1,9.544,5.3,3.181,3.181,0,0,1,12.725,2.121ZM2.64,9.448a3.181,3.181,0,1,1,2.043,4.009A3.182,3.182,0,0,1,2.64,9.448Zm8.3,11.152a3.181,3.181,0,1,1-.7-4.443A3.181,3.181,0,0,1,10.936,20.6Zm.729-7.875a1.06,1.06,0,1,1,1.06,1.06A1.06,1.06,0,0,1,11.665,12.725Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.8e0660630ed96825922eeb34f7167af4.svg";
export { ForwardRef as ReactComponent };